module.exports = __webpack_public_path__ + "static/media/logo-kab-sigi.15fa6ad2.png";